import { render } from "./Navbar.vue?vue&type=template&id=0d61171a&scoped=true"
import script from "./Navbar.vue?vue&type=script&lang=js"
export * from "./Navbar.vue?vue&type=script&lang=js"

import "./Navbar.vue?vue&type=style&index=0&id=0d61171a&lang=scss&scoped=true"

import exportComponent from "/home/forge/logistic.hoornbloommasters.com/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-0d61171a"]])

export default __exports__